import {Component, inject} from '@angular/core'
import {MatButton} from '@angular/material/button'
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogTitle} from '@angular/material/dialog'
import {IDocument} from '@sparbanken-syd/user-documents-backend'


@Component({
  selector: 'spb-show-documents',
  templateUrl: './show-documents.component.html',
  styleUrl: './show-documents.component.scss',
  imports: [
    MatDialogTitle,
    MatDialogActions,
    MatButton,
    MatDialogClose
  ]
})
export class ShowDocumentsComponent {
  public data = inject<{
    sub: string;
    documents: IDocument[];
  }>(MAT_DIALOG_DATA)
}
